"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function SvgLogopolisonov3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo_polisono_v3_svg__Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    width: 70,
    viewBox: "0 0 43 43",
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("style", null, ".logo_polisono_v3_svg__st1{fill:#fff}"), /*#__PURE__*/React.createElement("path", {
    d: "M.5 22c0-11.6 9.4-21 21-21 5.6 0 10.9 2.2 14.8 6.2s6.2 9.3 6.2 14.8c0 11.6-9.4 21-21 21S.5 33.6.5 22z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#0a6fb8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo_polisono_v3_svg__st1",
    d: "M19.4 19.3c0-1.7-1.3-3-2.9-3-1.6 0-2.9 1.3-2.9 3s1.3 3 2.9 3c1.6 0 2.9-1.3 2.9-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "logo_polisono_v3_svg__st1",
    d: "M27.9 16.4h-7.2c-.6 0-1 .5-1 1.1v5.3h-6.5v-10c0-.6-.5-1.1-1-1.1-.6 0-1 .5-1 1.1v16.9c0 .6.5 1.1 1 1.1.6 0 1-.5 1-1.1v-1.5h17.1v1.5c0 .6.5 1.1 1 1.1s1-.5 1-1.1V21c0-2.5-2-4.6-4.4-4.6z"
  }));
}
var _default = exports["default"] = SvgLogopolisonov3;